<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Notifications
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="8">
              <v-textarea
                v-model="form.message"
                outlined
                label="Write your notification here"
                prepend-inner-icon="mdi-card-text-outline"
              >
              </v-textarea>
            </v-col>
            <!-- 
            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (image_path = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col> -->
            <!-- /Start date -->
            <!-- <v-col sm="12">
              <label for="privacy-policy">Privacy Policy</label>
              <vue-editor
                ref="message"
                v-model="form.messages"
                class="form-control"
              />
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Notifications
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
// import { VueEditor } from "vue2-editor";
export default {
  name: "RawMaterialsCreatePage",
  // components: {
  //   VueEditor,
  // },
  data() {
    return {
      form: {
        title: "",
        message: "",
        type: 1,
      },
      isLoading: false,
      image_path: "",

      menu: false,
    };
  },
  mounted() {},
  methods: {
    getMasters() {
      axios
        .get("/users/masters")
        .then((masters) => {
          masters = masters.data;
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async save() {
      try {
        this.isLoading = true;
        let notification = await axios.post("/notifications", this.form);
        this.notification = notification.data.data;
        console.log("notification", this.notification);
        // await this.handleFileUpload();
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let attachment = this.$refs.file.files[0];
        let formData = new FormData();
        formData.append("id", this.notification.id);
        formData.append("image_path", attachment);
        await axios
          .post("upload_notification_image_path", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function (error) {
            console.log(error);
            console.log("FAILURE!!");
          });
      }
    },
    onFileChange() {
      this.warningImageLoader = false;
      this.file = this.$refs.file?.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          this.imageLoader = false;
          this.image_path = URL.createObjectURL(this.file);
          this.imageErrors = "";
        };
        img.src = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
      // this.image_path = URL.createObjectURL(this.file);
    },
  },
};
</script>
